import { useQuery } from '@tanstack/react-query';
import { api } from './client';

// Matches the response shape of GET /api/v2/me/.
// Keep this in sync with api_v2/views/me.py serializer fields.
export interface MeResponse {
  email: string;
  first_name: string;
  last_name: string;
  organization: {
    public_token: string | null;
    name: string;
  } | null;
  subscription: {
    plan_name: string;
    is_active: boolean;
    renewal_date: string | null;
  } | null;
  feature_flags: {
    workflows_enabled: boolean;
    api_access_enabled: boolean;
    ai_chat_enabled: boolean;
  };
  parse_count?: number;
  usage?: {
    parsed_count?: number;
    quota_limit?: number | null;
    remaining_quota?: number | null;
    remaining?: number | null;
    parses_left?: number | null;
    parses_remaining?: number | null;
  } | null;
  server_time: string;
}

/**
 * Hook for the SPA's session context. Called on every page load to
 * establish who the user is, which org, which plan, which features.
 *
 * Stale time: 5 minutes (subscription and org membership change rarely).
 * Invalidate this query after any mutation that changes plan or org.
 */
export function useMe() {
  return useQuery<MeResponse>({
    queryKey: ['me'],
    queryFn: async () => {
      const response = await api.get<MeResponse>('/v2/me/');
      return response.data;
    },
    staleTime: 5 * 60_000, // 5 minutes
  });
}
